/**
 *  Wise ID Auth Interceptor
 *  This interceptor adds the Wise ID access token to every ongoing HTTP request.
 *  It checks if the token is available in session storage and adds it to the request headers.
 *  If the token is not available, it simply forwards the request without modification.
 */

import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WiseIdAuthServiceManager } from './wise-id-auth.service-manager';


@Injectable()
export class WiseIdAuthInterceptor implements HttpInterceptor {
	constructor(private wiseIdAuthServiceManager: WiseIdAuthServiceManager) {
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const token = this.wiseIdAuthServiceManager.getAccessToken();
		if (token) {
			const cloned = req.clone({
				headers: req.headers.set('Authorization', `Bearer ${token}`)
			});
			return next.handle(cloned);
		}
		return next.handle(req);
	}
}